import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

const BARCODE_REGEX = /^\d{18}$/;
const MINIMUM_PHONE_LENGTH = 8;
const MAXIMUM_PHONE_LENGTH = 15;

const phoneUtil = PhoneNumberUtil.getInstance();

export const validateBarcode = (barcode: string): boolean => {
  if (!barcode || typeof barcode !== "string") {
    return false;
  }
  return BARCODE_REGEX.test(barcode);
};

export const validatePhone = (phone: string): boolean => {
  if (!phone || typeof phone !== "string" || phone.trim().length === 0) {
    return false;
  }

  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(phone);
    return phoneUtil.isValidNumber(parsedNumber);
  } catch {
    return false;
  }
};

export const isValidPhoneLength = (phoneNumber: string): boolean => {
  if (!phoneNumber || typeof phoneNumber !== "string") {
    return false;
  }

  if (phoneNumber.length < MINIMUM_PHONE_LENGTH) {
    return true;
  }
  if (phoneNumber.length > MAXIMUM_PHONE_LENGTH) {
    return false;
  }

  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(phoneNumber);
    const validationResult = phoneUtil.isPossibleNumberWithReason(parsedNumber);
    return validationResult !== PhoneNumberUtil.ValidationResult.TOO_LONG;
  } catch {
    return phoneNumber.length <= MAXIMUM_PHONE_LENGTH;
  }
};

export const parsePhoneNumberFromUrl = (
  phoneNumber?: string | null,
  defaultCountryCode = "US"
): string | null => {
  if (!phoneNumber || typeof phoneNumber !== "string") {
    return null;
  }

  try {
    let decodedNumber = decodeURI(phoneNumber).trim();

    if (!decodedNumber.startsWith("+")) {
      decodedNumber = `+${decodedNumber}`;
    }

    const parsedNumber = phoneUtil.parseAndKeepRawInput(
      decodedNumber,
      defaultCountryCode
    );

    if (phoneUtil.isValidNumber(parsedNumber)) {
      return phoneUtil.format(parsedNumber, PhoneNumberFormat.E164);
    }
    return null;
  } catch {
    return null;
  }
};

export const parseBarcodeFromUrl = (barcode?: string | null): string | null => {
  if (!barcode || typeof barcode !== "string") {
    return null;
  }

  return validateBarcode(barcode) ? barcode : null;
};
